import { authHeader, handleResponse } from '../helpers';
export const productAuthenticationService = {
    verifyProduct,
    UpdateFeedback,
    UpdateRequest,
    updateRating,
    fetchProductDLL,
    fetchProductID,
    fetchWarranty,
    CreateWarrantyForm,
    insertVerification
};

function verifyProduct(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/VerifyProduct`, requestOptions)
        .then(handleResponse);
}

function UpdateFeedback(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/UpdateFeedback`, requestOptions)
        .then(handleResponse);
}
function UpdateRequest(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/UpdateRequest`, requestOptions)
        .then(handleResponse);
}
function updateRating(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/UpdateRating`, requestOptions)
        .then(handleResponse);
}
function fetchProductDLL() {
    ;
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/GetProductDLL`, requestOptions)
        .then(handleResponse);
}

function fetchProductID(productData) {
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(productData)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/GetProductID`, requestOptions)
        .then(handleResponse);
}

function fetchWarranty(data) {
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/GetWarranty`, requestOptions)
        .then(handleResponse);
}

function CreateWarrantyForm(data) {
    
    
    const requestOptions = {
        method: 'POST',
        //headers: { 'Content-Type': 'application/json' },
        body: data
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/CreateWarrantyRegister`, requestOptions)
        .then(handleResponse);
}

function insertVerification(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/InsertVerification`, requestOptions)
        .then(handleResponse);
}






